import { serverSideTranslations } from "@/libs/i18n/serverSideTranslations";
import { ContactUsPageLayout } from "@/components/support/layouts/ContactUsPageLayout";
import { ContactUsData } from "@/models/ContactUs";
import PageTemplate from "@/components/templates/PageTemplate";
import { SupportDataProvider } from "@/v2-components/pages/support/context/support-data-context";
import type { SupportCategory } from "@/v2-components/pages/support/types/support-data";
import dynamic from "next/dynamic";

const ContactUs = dynamic(
  () => import("@/components/support/contactUs/contact-us"),
  { ssr: false },
);

const ContactUsPage = ({ contactUsData, categories }) => {
  return (
    <SupportDataProvider categories={categories}>
      <PageTemplate>
        <PageTemplate.Content>
          <ContactUsPageLayout>
            <ContactUs data={contactUsData} />
          </ContactUsPageLayout>
        </PageTemplate.Content>
      </PageTemplate>
    </SupportDataProvider>
  );
};

export async function getServerSideProps({ locale }) {
  const jsonData = require("@/../public/res/contact-us-support.json");
  const contactUsData: ContactUsData[] = jsonData || [];
  const supportJson = require("content/support/support.json");

  return {
    props: {
      contactUsData,
      categories: supportJson.categories as SupportCategory[],
      ...(await serverSideTranslations(locale, ["support", "gnb"])),
    },
  };
}
export default ContactUsPage;
